import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCg12ar9qfM9eQ7jgUXfBtoNZyR3_lIKaQ",
    authDomain: "rondago-prod.firebaseapp.com",
    projectId: "rondago-prod",
    storageBucket: "rondago-prod.firebasestorage.app",
    messagingSenderId: "494284294964",
    appId: "1:494284294964:web:8e6b2da1e495e7eda8b361",
  measurementId: "G-BKJT44C2KZ",
};

// Inicializar Firebase (evitar inicialização múltipla)
const app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();

// Exportar serviços do Firebase
const db = app.firestore(); // Firestore
const auth = app.auth(); // Autenticação

export { firebaseConfig, db, auth };
